module.exports = __webpack_public_path__ + "static/media/Crowding of teeth on one jaw 4.46f2d2bf.png";